import Link from "next/link";
import { ListItem } from "shared/components/molecules/ListItem";
import { Logo } from "shared/components/atoms/Logo";
import { Paths } from "utils/routes";
import { Announcement } from "shared/models";
import { css } from "twin.macro";

interface Props {
  announcement: Announcement;
}

export const AnnouncementListItem = ({ announcement }: Props) => {
  return (
    <Link href={Paths.announcements.show(announcement.id)}>
      <a>
        <ListItem
          renderImage={
            <div tw="bg-gradient-theme-to-l w-12 h-12 rounded-full flex-center">
              <Logo color="white" css={css({ transform: "scale(.6)" })} />
            </div>
          }
          title={announcement.title}
          text={announcement.publishedAtSinceNow}
        />
      </a>
    </Link>
  );
};
